import DynamicCardFeed from '../scripts/sections/DynamicCardFeed';
import DynamicComparison from '../scripts/sections/DynamicComparison';
import DynamicFeaturedProduct from '../scripts/sections/DynamicFeaturedProduct';
import DynamicLogoCarousel from '../scripts/sections/DynamicLogoCarousel';
import DynamicMediaWithText from '../scripts/sections/DynamicMediaWithText';
import DynamicProductFeed from '../scripts/sections/DynamicProductFeed';
import DynamicTestimonials from '../scripts/sections/DynamicTestimonials';
import DynamicTestimonialsSimple from '../scripts/sections/DynamicTestimonialsSimple';
import DynamicVideoTestimonials from '../scripts/sections/DynamicVideoTestimonials';
import DynamicCollectionReviews from '../scripts/sections/DynamicCollectionReviews';
import DynamicJobPostings from '../scripts/sections/DynamicJobPostings';
import DynamicYoutubeCarousel from '../scripts/sections/DynamicYoutubeCarousel';
import DynamicArticleFeed from '../scripts/sections/DynamicArticleFeed';
import DynamicCollectionCarousel from '../scripts/sections/DynamicCollectionCarousel';

// Sections
import MainCart from '../scripts/sections/MainCart';
import MainCollection from '../scripts/sections/MainCollection';
import MainHeader from '../scripts/sections/MainHeader';
import MainMinicart from '../scripts/sections/MainMinicart';
import MainProduct from '../scripts/sections/MainProduct';
import Sections from '../scripts/helpers/SectionManager';
import initAOS from '../scripts/global/initAos';
import initVideos from '../scripts/global/initVideos';
import initReadMore from '../scripts/global/initReadMore';

// Init global sections
const sections = new Sections();
sections.register('main-product', section => new MainProduct(section));
sections.register(
  'main-collection-grid',
  section => new MainCollection(section),
);
sections.register('main-header', section => new MainHeader(section));
sections.register('main-minicart', section => new MainMinicart(section));
sections.register('main-cart', section => new MainCart(section));
sections.register('main-search', section => new MainCollection(section));

sections.register(
  'dynamic-card-feed',
  section => new DynamicCardFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-product-feed',
  section => new DynamicProductFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-featured-product',
  section => new DynamicFeaturedProduct(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-logo-carousel',
  section => new DynamicLogoCarousel(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-media-w-text',
  section => new DynamicMediaWithText(section),
  {
    lazy: true,
  },
);

sections.register(
  'dynamic-testimonials',
  section => new DynamicTestimonials(section),
  {
    lazy: true,
  },
);

sections.register(
  'dynamic-testimonials-simple',
  section => new DynamicTestimonialsSimple(section),
  {
    lazy: true,
  },
);

sections.register(
  'dynamic-video-testimonials',
  section => new DynamicVideoTestimonials(section),
  {
    lazy: true,
  },
);

sections.register(
  'dynamic-collection-reviews',
  section => new DynamicCollectionReviews(section),
  {
    lazy: true,
  },
);

sections.register(
  'dynamic-comparison',
  section => new DynamicComparison(section),
  {
    lazy: true,
  },
);

sections.register(
  'dynamic-job-postings',
  section => new DynamicJobPostings(section),
  { lazy: true },
);

sections.register(
  'dynamic-youtube-carousel',
  section => new DynamicYoutubeCarousel(section),
  { lazy: true },
);

sections.register(
  'dynamic-article-feed',
  section => new DynamicArticleFeed(section),
  { lazy: true },
);

sections.register(
  'dynamic-collection-carousel',
  section => new DynamicCollectionCarousel(section),
  { lazy: true },
);

initAOS();
initVideos();
initReadMore();
